import React from "react";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { SectionPageTitleProps } from "src/library/types/types";
import ConnectathonInfo from "./ConnectathonInfo";
import ConnectathonLogo from "./ConnectathonLogo";
import { zIndexes } from "src/library/styles/theme";

export default function PageTitle(props: SectionPageTitleProps) {
  const { title, style } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        bgcolor: "common.black",
        p: isMobile ? 2 : 3,
        position: "relative",
        zIndex: zIndexes.Above,
        ...style,
      }}
      component="section"
    >
      <ConnectathonLogo alt={title} />
      <ConnectathonInfo />
    </Box>
  );
}
